import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'h3-annotation-list-section',
  templateUrl: './annotation-list-section.component.html',
  styleUrls: ['./annotation-list-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnnotationListSectionComponent {
  @Input() sectionNameLabel?: string;
}
